<template>
<div id="presentation" class="fixed-content">
  <page-section :header="require('@/assets/background.jpg')"
                title="La surveillance 2026">
    <div class="row feature-block-row">
      <div class="col-md-1" />
      <feature-block v-for="(b, k) in texts.common"
                     class="col-md-2 col-sm-4 col-xs-6"
                     :key="k" :title="b.title" :subtitle="b.subtitle"
                     :text="b.text" :icon="b.icon">
      </feature-block>
    </div>
  </page-section>
  <page-section type="dark-base"
                title="3 modalités aux choix">
    <div class="row">
      <div class="col-md-4 col-md-offset-0 col-sm-offset-2 col-sm-8">
        <div class="panel panel-bactADI">
          <div class="panel-heading text-center">
            <h2 class="panel-title">
              <strong>Bact ADI+</strong>
            </h2>
            <h4>
              Surveillance des bactériémies associées aux dispositifs invasifs
            </h4>
          </div>
          <div class="panel-body">
            <ul>
              <horizontal-feature-block v-for="(b, k) in texts.bacteriemie"
                                        :key="k" :title="b.title"
                                        :texts="b.texts" class="hfb-bactADI"
                                        :icon="b.icon">
              </horizontal-feature-block>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-sm-offset-2 col-sm-8 col-md-offset-0 col-md-4">
        <div class="panel panel-expADI">
          <div class="panel-heading text-center">
            <h2 class="panel-title"><strong>Exp ADI</strong></h2>
            <h4>
              Surveillance des infections avec étude de l'exposition aux
              dispositifs invasifs à l'échelle du service
            </h4>
          </div>
          <div class="panel-body">
            <ul>
              <horizontal-feature-block v-for="(b, k) in texts.exp"
                                        :key="k" :title="b.title"
                                        class="hfb-expADI" :texts="b.texts"
                                        :icon="b.icon">
              </horizontal-feature-block>
            </ul>
            <div class="row">
              <div class="col-xs-4 col-xs-offset-4">
                <img class="img-responsive"
                     :src="require('@/assets/img/logo-ecdc.png')"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-md-offset-0 col-sm-offset-2 col-sm-8">
        <div class="panel panel-reaInfADI">
          <div class="panel-heading text-center">
            <h2 class="panel-title"><strong>Réa/Néo/Dia Inf ADI</strong></h2>
            <h4>
              Surveillance des infections avec étude de l'exposition aux
              dispositifs invasifs à l'échelle du patient
            </h4>
          </div>
          <div class="panel-body">
            <ul>
              <horizontal-feature-block v-for="(b, k) in texts.reaI"
                                        :key="k" :title="b.title"
                                        :class="`hfb-${b.type}`"
                                        :texts="b.texts"
                                        :icon="b.icon">
              </horizontal-feature-block>
            </ul>
            <div class="row">
              <div class="col-xs-4 col-xs-offset-4">
                <img class="img-responsive"
                     :src="require('@/assets/img/logo-ecdc.png')"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </page-section>
  <page-section title="Téléchargements">
    <downloads />
  </page-section>
</div>
</template>

<script>
import downloads from '@/components/presentation/downloads'
import linkBlock from '@/components/linkBlock'
import pageSection from '@/components/pagesection'
import featureBlock from '@/components/featureBlock'
import horizontalFeatureBlock from '@/components/horizontalFeatureBlock'
import sc from '@/sc/presentation'
import { mapGetters } from 'vuex'

export default {
  name: 'presentation',

  data () {
    return {
    }
  },

  computed: {
    ...mapGetters({
      isLoggedIn: 'user/isLoggedIn'
    }),

    texts: function () {
      return sc.texts
    },

    files: function () {
      return sc.files
    }
  },

  components: {
    'downloads': downloads,
    'feature-block': featureBlock,
    'link-block': linkBlock,
    pageSection,
    'horizontal-feature-block': horizontalFeatureBlock
  },

  methods: {
    add () {
      this.$router.push('establishments')
    }
  }
}
</script>

<style scoped lang="less">
@import '~variables';

.feature-block-row {
    @media (min-width: @screen-sm-min) and (max-width: @screen-sm-max){
        .col-sm-4:nth-child(4n+1) {
            clear: both;
        }
    }
}

.feature-block {
    margin-bottom: 10rem;
}

ul {
    padding-left: 1rem;
    padding-right: 1rem;
}

h2.panel-title {
    font-size: 180%;
}
</style>
